import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: '', loadChildren: () =>
      import('./views/themes/default-theme-new/default-theme-new.routes').then(r => r.DefaultThemeNewRoutes)
  },
  {
    path: 'auth',
    loadChildren: () => import('./views/pages/new-auth/new-auth.routing'),
  },
  {
    path: 'certificate-wallets',
    loadChildren: () => import('./views/pages/certificate-wallets/certificate-wallets-routing').then(r => r.CertificateWalletsRoutes),
  },
  {
    path: 'security-app',
    loadChildren: () => import('./views/pages/mobile-alerts/mobile-alerts.routing').then(r => r.MobileAlertsRoutes),
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
